export default "__VITE_ASSET__DxlZE1ma__"